import * as Yup from "yup";
import { Formik } from "formik";

import { fetchUserToken } from "../../redux/api/auth.api";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import TextInput from "../../components/misc/TextInput";
import ContentCard from "../../components/misc/ContentCard";
import CustomButton from "../../components/CustomButton";
import { toAbsoluteUrl } from "../../helpers/assetHelper";

const loginSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, "Minim 3 caractere")
    .max(50, "Maxim 50 caractere")
    .required("Adaugati un nume de utilizator"),
  password: Yup.string()
    .min(3, "Minim 3 caractere")
    .max(50, "Maxim 50 caractere")
    .required("Adaugati o parola"),
});

const initialValues = {
  name: "",
  password: "",
};

const Login = () => {
  const dispatch = useAppDispatch();

  const {
    auth: { isLoadingToken, isErrorToken, errorMessageToken },
    user: { isLoadingUser },
  } = useAppSelector((state) => ({
    auth: state.auth,
    user: state.user,
  }));

  const isLoading = isLoadingToken || isLoadingUser;

  const handleLogin = async (values: any) => {
    const userData = {
      userName: values.name,
      password: values.password,
    };
    dispatch(fetchUserToken(userData));
  };

  return (
    <div className="flex h-full flex-col items-center justify-center px-3">
      <ContentCard
        className="w-full max-w-[460px] !px-8 !py-10"
        cardHeaderClassName="!pt-0"
        CardHeader={() => (
          <div className="mb-8 flex flex-col items-center gap-4 text-center">
            <img
              src={toAbsoluteUrl("/logo.svg")}
              alt="WMS"
              width={160}
              height={48}
              className="block h-auto max-w-full"
            />
            <div aria-hidden="true" className="h-px w-16 bg-slate-200" />
            <h1 className="m-0 text-2xl font-semibold text-slate-900">
              Autentificare
            </h1>
          </div>
        )}>
        <Formik
          initialValues={initialValues}
          validationSchema={loginSchema}
          onSubmit={handleLogin}>
          {({
            status,
            isValid,
            errors,
            touched,
            getFieldProps,
            handleSubmit,
            isSubmitting,
          }) => (
            <form
              aria-label="Autentificare WMS"
              className="w-full"
              onSubmit={handleSubmit}
              noValidate
              id="kt_login_signin_form">
              <TextInput
                name="name"
                label="Username"
                error={errors["name"]}
                touched={touched["name"]}
                inputProps={getFieldProps("name")}
              />
              <TextInput
                name="password"
                label="Password"
                type="password"
                error={errors["password"]}
                touched={touched["password"]}
                inputProps={getFieldProps("password")}
              />
              {(status || isErrorToken) && (
                <div
                  role="alert"
                  className="mb-5 rounded-control bg-danger-subtle px-4 py-3 text-danger">
                  {status || errorMessageToken || "Autentificarea a eșuat. Încearcă din nou."}
                </div>
              )}
              <CustomButton
                type="submit"
                fullWidth
                variant="contained"
                size="large"
                className="w-full !min-h-[48px] !text-base"
                disabled={!isValid || isSubmitting || isLoading}
                loading={isLoading}>
                Continua
              </CustomButton>
            </form>
          )}
        </Formik>
      </ContentCard>
    </div>
  );
};

export default Login;
